import { render, staticRenderFns } from "./name.vue?vue&type=template&id=30ce5ca0"
import script from "./name.vue?vue&type=script&lang=js"
export * from "./name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports